import { ProductUiDto } from '@whiz-cart/node-shared/models/product/productUiDto';

export const PRODUCTS_LIST = 'PRODUCTS_LIST';
export const LOADING_SEARCH_PRODUCT_LIST = 'LOADING_SEARCH_PRODUCT_LIST';
export const SEARCH_PRODUCTS_LIST = 'SEARCH_PRODUCTS_LIST';
export const CLEAR_SEARCH_PRODUCTS_LIST = 'CLEAR_SEARCH_PRODUCTS_LIST';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const CLEAR_ITEM = 'CLEAR_ITEM';

export const loadProducts = (list: ProductUiDto[]) => ({ type: PRODUCTS_LIST, payload: list });
export const loadSearchProducts = (list: ProductUiDto[]) => ({ type: SEARCH_PRODUCTS_LIST, payload: list });
export const clearSearchList = () => ({ type: CLEAR_SEARCH_PRODUCTS_LIST });
export const addProduct = (item: ProductUiDto) => ({ type: ADD_PRODUCT, payload: item });
export const deleteProduct = (itemId: string) => ({ type: DELETE_PRODUCT, payload: itemId });
export const clearItem = () => ({ type: CLEAR_ITEM });
export const isLoading = () => ({ type: LOADING_SEARCH_PRODUCT_LIST });
